<template>
  <b-overlay
    :show="__isOnLoad"
    variant="white"
    rounded
    opacity="0.70"
    spinner-variant="primary"
    spinner-small
    style="float: left; width: 100%"
  >
  <b-modal 
    v-if="showFact !== null"
    v-model="showPopup"
          centered
          modal-class="app-popup-shell"
          dialog-class="app-popup-dialog"
          content-class="app-popup-content"
          body-class="app-popup-body"
          :hide-footer= "true"
          size="xl"
          title="" header-class="app-popup-header"
          >
          <Template :__object="showFact"  v-if="showFact !== null"></Template>
  </b-modal>

    <div class="recap">
      <div class="history">
        Qte vendu : {{qteVente}} <br />
        Factures : <b-icon icon="exclamation-circle-fill" style="color: green" font-scale="1" @click="showHist = !showHist" title="Voir l'historique"></b-icon> {{factVente}}<br />

        <b>CA : {{ formatMoney(totalVente) }} HT</b><br />
      </div>

      <div class="info" v-if="item">
        <div class="pic">
          <img :src="getTof(item.pic)" style="width: 80px" />
        </div>
        <em>{{ item.ref}}</em>
        <h1>{{ item.name }}</h1>
        <h3><b>{{ item.catID }}</b> {{ item.marqueID }}</h3>
        <em
          >Stock : <b>{{ item.stock }}</b> - PUR : <b>{{ formatMoney(item.prixA) }}</b> - PUV : <b>{{ formatMoney(item.prixV) }}</b>:
          <b>{{ item.fax }}</b></em
        >
        
      </div>

      <div
        class="row item"
        v-for="(_item, idx) in history"
        :key="idx"
        v-if="showHist"
      >

        <div class="col-md-1"><b-icon icon="card-heading" style="color: blue" font-scale="1.5" title="Voir la facture" @click="fnshowFact(_item)"></b-icon></div>
        <div class="col-md-3 "><b>N° {{ _item.num }} / {{ _item.exercice }}</b> <br />
          <em style="font-size: 10px">{{
            __._getDate(_item.createdAt)
          }}</em></div>
        <div class="col-md-3"><b>{{_item.owner.name}}</b></div>
        <div class="col-md-3 ">{{_item.QTE}} - {{_item.REM}}%</div>
        <div class="col-md-2 "> {{ formatMoney(_item.PU) }}</div>

      </div>
    </div>
  </b-overlay>
</template>
<script>
import Vue from "vue";
import Template from "@/pages/commun/Template";
export default {
  components: {Template},
  props: {
    __ID: {
      type: String,
      default: () => {
        return "";
      },
    },
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    __showHist: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },

  data() {
    return {
      item: null,
      onGoingReq: [],
      factVente: 0,
      totalVente: 0,
      qteVente: 0,
      showHist: false,
      history: [],
      showFact: null,
      showPopup: false
    };
  },
  methods: {
    formatMoney(value) {
      return Number(value || 0).toFixed(3);
    },

    loadData() {
      let $onNext = (response) => {
        this.item = response.data[0];
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      this.__.httpAction({
        methode: "GET",
        route: "/prods/" + this.$props.__ID,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },
    
    fnshowFact(fact) {
      this.showFact = fact
      this.showPopup = true
    },

    loadFact() {
      let $onNext = (response) => {
        this.qteVente = 0;
        this.totalVente = 0;
        this.history = response.data;
        this.factVente = this.history.length
        this.history = this.history.map(fact => {
          fact.devis.map(article => {
            if(article.id === this.$props.__ID) {
              this.qteVente += article.qte;
              this.totalVente += (Number(article.total));
              fact.PU = (Number(article.total) / article.qte).toFixed(3)
              fact.QTE = article.qte
              fact.REM = article.remise
            }
          })
          return {...fact}
        })
        .sort((a,b) => Number(a.PU || 0) - Number(b.PU || 0))
      };

      const $onError = () => {};
      const $onComplete = () => {
        if (this.onGoingReq.length > 0) this.onGoingReq.pop();
      };

      this.onGoingReq.push({});
      const exercice = Vue.$cookies.get("exercice");

      this.__.httpAction({
        methode: "GET",
        route: '/factures/FACTURE/'+exercice+'/byArticle/'+this.$props.__ID,
        data: {},
        onNext: $onNext,
        onError: $onError,
        onComplete: $onComplete,
      });
    },

    getTof(c) {
      return this.__.resolveMediaPath(c, "uploads/catalogue/No-Image.jpg");
    },
  },
  watch: {
    __ID: function () {this.loadData(), this.loadFact()},
  },
  computed: {},
  mounted() {
    this.showHist = this.$props.__showHist;
    setTimeout(() =>{ this.loadData(); this.loadFact()}, 400);
  },
};
</script>
<style scoped>
.item {
  margin-left: 0px !important;
  margin-right: 0px !important;
  background-color: #f2F2F2;
  margin-top: 2px;
  border-radius: 10px;
  color: black;
  font-size: 12px;
  padding: 5px
}
.recap {
  padding: 10px;
  border-radius: 10px;
  background-color: #ff9843;
  color: #fff;
  font-size: 10px;
  margin-bottom: 10px
}
.pic {
  width: 80px;
  float: left;
  margin-right: 10px;
}
h1 {
  font-size: 20px;
  color: #000;
}
h3 {
  font-size: 10px;
  color: #000;
}

.info {
}
.history {
  float: right;
  color: #000;
  font-size: 12px;
}
</style>

